import {HttpHeaders, HttpResponse} from '@angular/common/http';
import {ConfigurationService} from "~/app/core/services/configuration.service";
import {ErrorService} from "~/app/core/services/error.service";
import {Injectable} from "@angular/core";
import {Group} from "~/app/core/reports/models/group";
import {Chain} from "@model/Chain";


import {HotStore} from "@model/HotStore";
import {BaseService} from './base.service';
import { lastValueFrom } from 'rxjs';

const REPORT = '/report';
const RESTPATH = '/fs-online-invoicing-ws/rest/v1';
const GET_STORES = '/storegroups/';
const ASSGN = '/assigned/'; // {hoId}/{groupid}
const UNASSGN = '/unassigned/'; // {hoId}/{groupid}
const HEADERS = '/storegrouphdrs/';
const CREATE = '/group/';
const UPDATE = '/groups';
const ADD = '/storegroups/';
const REMOVE = '/storeupdate/';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
  }),
};

@Injectable({
  providedIn: 'root'
})

export class StoreReportGroupingService {
  groupHeaders: Group[];
  _groupId: string;
  _astores: HotStore[];
  _ustores: HotStore[];
  _groupDesc: string;


  constructor(private baseService: BaseService,
              private configuration: ConfigurationService,
              private errorService: ErrorService) {
  }

  setAStores(astores: HotStore[]) {
    this._astores = [];
    this._astores = astores;
  }

  getAStores(): HotStore[] {
    return this._astores;
  }

  setUStores(ustores: HotStore[]) {
    this._ustores = [];
    this._ustores = ustores;
  }

  getUStores(): HotStore[] {
    return this._ustores;
  }

  setGroupIdValue(groupId: string) {
    this._groupId = groupId;
  }

  getGroupIdValue(): string{
    return this._groupId;
  }

  setGroupDesc(groupDesc: string){
    this._groupDesc = groupDesc;
  }

  getGroupDesc(): string {
    return this._groupDesc;
  }



  getStores(hoId: string, userId: string): Promise<Chain[]> {
    return lastValueFrom(this.baseService.getHttpObject<any>(
      'getStores',
      'store-report-grouping-service',
      this.configuration.RESTURL + REPORT + GET_STORES + hoId + '/' + userId))
      .catch(this.errorService.handleError('store-report-grouping.service getStores', []))
  }

  async getGroupHeaders(hoId: string): Promise<Group[]> {
    return lastValueFrom(this.baseService.getHttpObject<Group[]>(
      'getGroupHeaders',
      'store-report-grouping-service',
      this.configuration.RESTURL + REPORT + HEADERS + hoId + '/'))
  }

  createGroup(hoId: string, groupId: string, groupName: string): Promise<Object> {
    let newItem = {
      "hoID": hoId,
      "groupId": groupId,
      "groupDesc": groupName
    }
    return lastValueFrom(this.baseService.postHttpJsonObject<any>(
      'createGroup',
      'store-report-grouping-service',
      this.configuration.RESTURL + REPORT + CREATE, JSON.stringify(newItem)))
  }

  deleteGroup(hoId: string, groupId: string): Promise<Object> {
    return lastValueFrom(this.baseService.deleteHttp(
      'deleteGroup',
      'store-report-grouping-service',
      this.configuration.RESTURL + REPORT + CREATE + hoId + '/' + groupId))
  }

  updateGroup(items: any, hoId: any, username: string) {
    let newItems = [];

    items.forEach((item) => {
      let newItem = {
        "hoID": item.hoID,
        "chainID": item.chainID,
        "storeID": item.storeID,
        "storeGroups": item.storeGroups
      }
      newItems.push(newItem);
    })
    return lastValueFrom(this.baseService.postHttpJsonObject<any>(
      'updateGroup',
      'store-report-grouping-service',
      this.configuration.RESTURL + REPORT + UPDATE + '/' + hoId + '/' + username, JSON.stringify(newItems), {
        headers: httpOptions.headers,
        observe: 'response'
      }));
  }

  getAssignedStores(hoId: string, groupId: string): Promise<HotStore[]> {
    return lastValueFrom(this.baseService.getHttpObject<any>(
      'getAssignedStores',
      'store-report-grouping-service',
      this.configuration.RESTURL + REPORT + ASSGN + hoId + '/' + groupId))
      .catch(this.errorService.handleError('storeReportGroupService getAssignedStores()', []))
  }

  getUnassignedStores(hoId: string, groupId: string): Promise<HotStore[]> {
    return lastValueFrom(this.baseService.getHttpObject<any>(
      'getUnassignedStores',
      'store-report-grouping-service',
      this.configuration.RESTURL + REPORT + UNASSGN + hoId + '/' + groupId))
      .catch(this.errorService.handleError('storeReportGroupService getAssignedStores()', []))
  }

  updateStoreGrouping(hotStores: HotStore[]): Promise<Object> {
    return lastValueFrom(this.baseService.postHttpJson(
      'addStorestoGroup',
      'store-report-group',
      this.configuration.RESTURL + REPORT + ADD, JSON.stringify(hotStores)))
      .catch(this.errorService.handleError('storeReportGroupingService', []));
  }

  removeStoreGrouping(hotStores: HotStore[]): Promise<Object> {
    return lastValueFrom(this.baseService.postHttpJson(
      'removeStoreGroup',
      'store-report-group',
      this.configuration.RESTURL + REPORT + REMOVE, JSON.stringify(hotStores)))
      .catch(this.errorService.handleError('storeReportGroupingService', []));
  }
}

